module.exports = __webpack_public_path__ + "static/media/physics-che-big.dd05e731.png";